import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-benefit-image-card',
  templateUrl: './benefit-image-card.component.html',
  styleUrls: ['./benefit-image-card.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule]
})
export class BenefitImageCardComponent {
  @Input() hasNotification: boolean;
  @Input() layout: string;
  @Input() bannerImage: string;
  @Input() cardText: string;
  @Input() cardCode: string;

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  textLengthCheck(cardText) {
    return (cardText.length <= 16 && window.innerWidth < 375) || (cardText.length <= 17 && window.innerWidth >= 375);
  }

  manipulateText(target: HTMLElement) {
    let titles = document.getElementsByClassName("title");
    let cards = document.getElementsByClassName("benefit-image-card");

    for (let i = 0; i < titles.length; i++) {
      if (titles[i].id !== target.id) {
        titles[i].classList.remove('expanded-title');
      }
    }
    for (let i = 0; i < cards.length; i++) {
      if (cards[i].id !== target.parentElement.parentElement.parentElement.id) {
        cards[i].classList.remove('expanded-card');
      }
    }

    if (target.classList.contains('expanded-title')) {
      target.classList.remove('expanded-title')
      target.parentElement.parentElement.parentElement.classList.remove('expanded-card');
    } else {
      target.classList.add('expanded-title');
      target.parentElement.parentElement.parentElement.classList.add('expanded-card');
    }
  }
}
